import FormGeneralError from 'components/formComponents/FormGeneralError';
import React, { useState } from 'react';
import { PopupOrPanel } from '../../components/popupsAndPanels/PopupAndPanels';
import { MyDocumentsApi } from '../../api/myDocumentsApi';
import { useDispatch } from 'react-redux';
import { setUpdateMyDocumentsList } from 'reducers/misc';
import WarningIcon from 'images/Icon_Warning_01.png';

type Props = {
  panelOpen: boolean;
  togglePanelOpen: React.Dispatch<React.SetStateAction<boolean>>;
  addPluralTxt: boolean | undefined;
  ids: number[];
  fileType: any;
  itemNames: string[];
};

export const DeleteDocuments: React.FC<Props> = ({
  panelOpen,
  togglePanelOpen,
  addPluralTxt,
  ids,
  fileType,
  itemNames,
}) => {
  const dispatch = useDispatch();

  const [error, setError] = useState<string>('');
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);

  const deleteUser = async () => {
    setError('');
    setIsSubmitting(true);

    const result = await MyDocumentsApi.deleteFile(ids);

    if (result.data) {
      dispatch(setUpdateMyDocumentsList(true));
      togglePanelOpen(false);
    }

    if (result.error) {
      setError(error);
      setIsSubmitting(false);
    }
  };

  let popupTxt = fileType[2]
    ? addPluralTxt
      ? 'these items'
      : 'this item'
    : fileType[1]
    ? addPluralTxt
      ? 'these folders'
      : 'this folder'
    : addPluralTxt
    ? 'these documents'
    : 'this document';

  return (
    <PopupOrPanel
      isPopup={true}
      isOpen={panelOpen}
      hdrTitle={`Delete file${addPluralTxt ? 's' : ''}/folder${
        addPluralTxt ? 's' : ''
      }`}
      position="right"
      primaryBtnTxt="Delete"
      secondaryBtnTxt="Cancel"
      givenClass="DeleteDocument"
      primaryBtnColor="BtnRed"
      handleClose={() => togglePanelOpen(false)}
      handlePrimaryBtn={deleteUser}
      handleSecondaryBtn={() => togglePanelOpen(false)}
      width={560}
      isSubmitting={isSubmitting}
      noOverflowToggle={true}
    >
      <div className="DeleteModal">
        <h4>Permanently Delete</h4>
        {error && <FormGeneralError message={error} />}
        {/* <p>Are you sure you want to delete {popupTxt}?</p> */}
        <p>{`Are you sure you want to delete ${
          addPluralTxt ? 'these' : 'this'
        }?`}</p>
        <div className="LineSpacer3"></div>
        <p>
          {/* <strong>
            You’ll permanently lose all information about {popupTxt}:
          </strong> */}
          <strong>
            {`You’ll permanently lose all information about ${
              addPluralTxt ? 'these files/folders' : 'this file/folder'
            }:`}
          </strong>
        </p>

        <ul className="DocDeleteList">
          {itemNames.map((item: any, index: number) => {
            return (
              <li className="DLItem" key={index}>
                {item}
              </li>
            );
          })}
        </ul>

        <div className="Warning RedBack">
          <img src={WarningIcon} alt="Warning" />
          <p>This action cannot be undone</p>
        </div>
      </div>
    </PopupOrPanel>
  );
};
